import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { Recruitment, RecruitmentComment } from '../types';
import { WithUsers } from '../../users';
import { uploadMutations } from 'entities/modules/uploads';

type RequestRecruitmentParams = {
  projectId: string;
  taskId: string;
  sampleId: string;
  country: string;
  gender: string;
  region: string;
  selIncome: string;
  requestComment: string;
  completesNecessary: number;

  ageRange: {
    from: number;
    to: number;
  };
};

export const recruitmentMutations = getMutations({
  requestRecruitment: {
    action: async (payload: RequestRecruitmentParams): Promise<Recruitment> => {
      return executeApiCall({
        path: '/projects/recruitments',

        method: 'post',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('recruitment-requested'),
      }),
    },
  },

  denyRecruitment: {
    action: async (payload: {
      recruitmentId: string;
      justification: string;
    }): Promise<Recruitment> => {
      return executeApiCall({
        path: '/projects/recruitments/deny',

        method: 'post',

        payload,
      });
    },
  },

  finishRecruitment: {
    action: async (payload: { recruitmentId: string }): Promise<Recruitment> => {
      return executeApiCall({
        path: '/projects/recruitments/finish',

        method: 'post',

        payload,
      });
    },
  },

  activateRecruitment: {
    action: async (payload: { recruitmentId: string }): Promise<{ recruitmentId: string }> => {
      return executeApiCall({
        path: '/projects/recruitments/activate',

        method: 'post',

        payload,
      });
    },
  },

  assignRecruitment: {
    action: async (payload: { recruitmentId: string; owner: string }): Promise<Recruitment> => {
      return executeApiCall({
        path: '/projects/recruitments/owner',

        method: 'post',

        payload,
      });
    },
  },

  changeRecruitmentOwner: {
    action: async (payload: {
      recruitmentId: string;
      owner: string;
      justification: string;
    }): Promise<Recruitment> => {
      return executeApiCall({
        path: '/projects/recruitments/owner',

        method: 'put',

        payload,
      });
    },
  },

  createRecruitmentComment: {
    action: async ({
      files = [],
      ...payload
    }: {
      recruitmentId: string;
      text: string;
      files?: File[];
    }): Promise<WithUsers<RecruitmentComment, 'user'>> => {
      const filePayload = await uploadMutations.multiFileUpload.action({
        files,
        prefix: `recruitments/${payload.recruitmentId}`,
      });

      return executeApiCall({
        path: '/projects/recruitments/comments',

        method: 'post',

        payload: {
          ...payload,
          ...filePayload,
        },
      });
    },
  },

  editRecruitmentComment: {
    action: async (payload: {
      recruitmentId: string;
      timestamp: string;
      text: string;
    }): Promise<WithUsers<RecruitmentComment, 'user'>> => {
      return executeApiCall({
        path: '/projects/recruitments/comments',

        method: 'put',

        payload,
      });
    },
  },
});
